import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

import { GdsBaggageAndVipServiceType } from '../../../../types';
import { useGdsServicesCalculatedCountInfo } from './useGdsServicesCalculatedCountInfo';
import { getGdsServiceCalculatedCountInfo } from './getGdsServiceCalculatedCountInfo';

export function useGetGdsServicesCalculatedCountInfo() {
	const gdsServicesCalculatedLimitInfo = useGdsServicesCalculatedCountInfo();

	return (
		passengerId: string,
		segmentId: string,
		params: {
			rfisc?: string;
			type?: OrderAdditionalServiceGdsServiceServiceType;
			subType?: GdsBaggageAndVipServiceType;
		}
	) => getGdsServiceCalculatedCountInfo(passengerId, segmentId, gdsServicesCalculatedLimitInfo, params);
}
